<template>
  <div>
    <sweet-modal blocking ref="addTask" class="modal" :title="stateTask === 'add' ? $t('modal_addNewTask') : stateTask === 'insert' ? $t('modal_addNewTask') : $t('modal_editTask')" v-on:close="closeTaskModal">
      <el-form :model="formAddTask" status-icon :rules="rules" ref="formAddTask" class="demo-ruleForm">

        <el-row :gutter="20">
          <el-col :span="24" :offset="0">
            <!-- :label="$t('modal_name')" label-width="100px" -->
            <el-form-item size="mini" prop="taskName">
              <el-input :placeholder="$t('modal_taskName')" v-model="formAddTask.taskName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_type')" label-width="100px" -->
            <el-form-item size="mini" prop="typeTaskId">
              <el-tooltip :content="$t('modal_inDevelopment')" placement="top">
                <el-select :disabled="true" no-data-text="no date" v-model="formAddTask.typeTaskId" :placeholder="$t('modal_taskType')">
                    <el-option
                      v-for="item in formAddTask.typeTask"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      @click.native="handleTaskFunctions('getTaskFunctionList', item.id)">
                    </el-option>
                </el-select>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_function')" label-width="100px" -->
            <el-form-item size="mini" prop="functionTaskId">
              <el-tooltip :content="$t('modal_inDevelopment')" placement="top">
                <el-select :disabled="true" no-data-text="no date" v-model="formAddTask.functionTaskId" :placeholder="$t('modal_taskFunction')">
                  <el-option
                    label="Default task function"
                    :value="1">
                  </el-option>
                </el-select >
              </el-tooltip>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_chooseADate')" label-width="120px" -->
            <el-form-item size="mini" prop="Date">
              <el-date-picker
                v-model="formAddTask.Date"
                type="datetimerange"
                prefix-icon="el-icon-date"
                align="center"
                range-separator=""
                :start-placeholder="$t('modal_startDate')"
                :end-placeholder="$t('modal_endDate')"
                format="d MMM yy h:mm a"
                value-format="timestamp"
                style="width: 100%;">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_stage')" label-width="100px" -->
            <el-form-item size="mini" prop="taskStageId">
              <el-select v-model="formAddTask.taskStageId" :placeholder="$t('modal_taskStage')">
                <el-option
                  v-for="stage in formAddTask.taskStage"
                  :key="stage.id"
                  :label="stage.name"
                  :value="stage.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <br>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_priority')" label-width="100px" -->
            <el-form-item size="mini" prop="taskPriorityId">
              <el-select v-model="formAddTask.taskPriorityId" :placeholder="$t('modal_taskPriority')">
                <el-option
                  v-for="priority in formAddTask.taskPriority"
                  :key="priority.id"
                  :label="priority.name"
                  :value="priority.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="aboutButton">
            <el-button style="width: 100%;" class="btn-wrap" slot="button" v-on:click="$refs.aboutTask.open()" size="medium" type="primary" plain>{{$t('modal_aboutThisTask')}}</el-button>
        </div>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_taskTeam')" label-width="100px" -->
            <el-form-item size="mini" prop="taskTeamId">
              <treeselect
                :placeholder="$t('modal_taskTeam')"
                :multiple="true"
                :options="formAddTask.taskTeam"
                :disable-branch-nodes="true"
                v-model="formAddTask.taskTeamId"
                :beforeClearAll="beforeClearAll"
                @deselect="deselect"
                @select="selectTeam"
                search-nested
                />
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_leader')" label-width="100px" -->
            <el-form-item size="mini" prop="assignedToId">
              <el-select v-model="formAddTask.assignedToId" :placeholder="$t('modal_assignedTo')" filterable clearable @clear="clearLeader">
                <el-option
                  v-for="assign in formAddTask.assignedTo"
                  :key="assign.id"
                  :label="assign.user.fullName"
                  :value="assign.id"
                  :class="{ disabled: assign.status != 1 }"
                  @click.native="handleSelectLeader(assign.id)"></el-option>
              </el-select>
            </el-form-item>
            <!-- :label="$t('modal_businessUnit')" label-width="100px" -->
            <el-form-item v-if="formAddTask.assignedToId" size="mini" prop="businessUnitId">
              <el-radio-group v-model="formAddTask.businessUnitId">
                <el-row v-for="businessUnit in formAddTask.businessUnitList" :key="businessUnit.id">
                  <el-radio :label="businessUnit.id">{{businessUnit.name}}</el-radio>
                </el-row>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_clients')" label-width="100px" -->
            <el-form-item size="mini" prop="projectClientListId">
              <el-select no-data-text="no date" v-model="formAddTask.projectClientListId" multiple placeholder="Clients">
                <el-option-group
                  class="select-group"
                  @click.native="ggg(group)"
                  v-for="group in newClientList"
                  :key="group.companyClientId"
                  :label="group.companyClient.name">
                  <el-option
                    v-for="item in group.people"
                    :key="item.id"
                    :label="item.fullName"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- label-width="100px" -->
            <el-form-item prop="allowExternalNotification" size="mini">
              <el-switch active-color="#13ce66" v-model="formAddTask.allowExternalNotification"></el-switch> {{$t('modal_allowClientVendorNotification')}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_vendors')" label-width="100px" -->
            <el-form-item size="mini" prop="projectVendorListId">
              <el-select v-model="formAddTask.projectVendorListId" placeholder="Vendors" multiple>
                <el-option-group
                  class="select-group"
                  @click.native="ggg(group)"
                  v-for="group in newVendorList"
                  :key="group.companyVendorId"
                  :label="group.companyVendor.name">
                  <el-option
                    v-for="item in group.people"
                    :key="item.id"
                    :label="item.fullName"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- label-width="100px" -->
            <el-form-item prop="addTaskDocuments" size="mini">
              <el-switch active-color="#13ce66" v-model="formAddTask.addTaskDocuments"></el-switch> {{$t('modal_addTaskDocuments')}}
            </el-form-item>
          </el-col>
        </el-row>

        <!-- DM -->
        <el-row :gutter="20" v-if="formAddTask.addTaskDocuments">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_sop')" label-width="100px" -->
            <el-form-item prop="sopListId" size="mini">
              <el-select v-model="formAddTask.sopListId" :placeholder="$t('modal_sop')" clearable>
                <el-option v-for="item in formAddTask.sopList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_policy')" label-width="100px" -->
            <el-form-item prop="policyListId" size="mini">
              <el-select v-model="formAddTask.policyListId" :placeholder="$t('modal_policy')" clearable>
                <el-option v-for="item in formAddTask.policyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="formAddTask.addTaskDocuments">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_healthSafety')" label-width="100px" -->
            <el-form-item prop="healthSafetyListId" size="mini">
              <el-select v-model="formAddTask.healthSafetyListId" :placeholder="$t('modal_healthSafety')" clearable>
                <el-option v-for="item in formAddTask.healthSafetyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_commercial')" label-width="100px" -->
            <el-form-item prop="riskAssesmentListId" size="mini">
              <el-select v-model="formAddTask.riskAssesmentListId" :placeholder="$t('modal_commercial')" clearable>
                <el-option v-for="item in formAddTask.riskAssesmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20" v-if="formAddTask.addTaskDocuments">
          <el-col :span="12" :offset="0">
            <!-- :label="$t('modal_general')" label-width="100px" -->
            <el-form-item prop="envirenmentalListId" size="mini">
              <el-select v-model="formAddTask.envirenmentalListId" :placeholder="$t('modal_general')" clearable>
                <el-option v-for="item in formAddTask.envirenmentalList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0"></el-col>
        </el-row>

        <div class="flex-end">
          <el-form-item class="modal__btn">
            <el-button size="medium" @click="modalCancel('addTask')">{{$t('general_cancel')}}</el-button>
            <el-button size="medium" v-if="stateTask === 'add'"  @click="addTaskSubmit('formAddTask')" type="primary">{{$t('general_submit')}}</el-button>
            <el-button size="medium" v-if="stateTask === 'insert'"  @click="addTaskInsert('formAddTask')" type="primary">{{$t('general_submit')}}</el-button>
            <el-button size="medium" v-if="stateTask === 'edit'"   @click="editTaskSubmit('formAddTask')" type="primary">{{$t('general_submit')}}</el-button>
          </el-form-item>
        </div>
      </el-form>
    </sweet-modal>

    <sweet-modal blocking ref="aboutTask">
      <vue2-custom-editor
          ref="editor"
          :placeholder="$t('modal_aboutThisTask')"
          style="margin-bottom: 20px;"
          v-model="formAddTask.aboutThisTask">

      </vue2-custom-editor>
      <div class="modal__btn">
        <el-button v-on:click="$refs.aboutTask.close()" type="primary">{{$t('general_ok')}}</el-button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios'
  import Vue2CustomEditor from "../vue-2-custom-editor";
  // import moment from 'moment'
  let moment = require('moment')
    export default {
      components:{
        Vue2CustomEditor,
        SweetModal,
        Treeselect,
      },
      props:['selectedRow','activeProjectId'],
      data() {
        return {
          countOpenModal: 1,
          moment:moment,
          businessUnitsId: null,
          businessUnits: [],
          businessUnitsUsersId: [],
          businessUnitsUsers: [],
          companyUserList: [],

          newClientList:[],
          newVendorList:[],
          maximumDate: '',
          minimumDate: '',
          value: '',
          projectTaskId: '0',
          stateTask: 'add',
          // firstEntering: false,
          // Modal form Add Task
          formAddTask: {
            taskName: '',
            aboutThisTask: null,
            // functionTaskId: '',
            functionTaskId: 1,
            functionTask: [],
            taskStageId: '',
            taskStage: [],
            taskPriorityId: '',
            taskPriority: [],
            startDate: '',
            deadlineDate: '',
            assignedTo: [],
            assignedToId: null,
            taskTeam: [],
            taskTeamId: [],
            projectClientList: '',
            projectClientListId: [],
            sharedTeamId: [],
            shareProjectTaskCompanyUserList:[],
            projectVendorList: '',
            projectVendorListId: [],
            typeTask: '',
            // typeTaskId: '',
            typeTaskId: 1,
            businessUnitId: null,
            businessUnitList: [],
            Date: [],

            addTaskDocuments: false,
            allowExternalNotification: false,
            allowSharing: false,
            clients: '',
            vendors: '',

            assignSOP: '',
            assignPolicy: '',
            assignHealthSafety: '',
            assignRiskAssessment: '',
            assignEnvironmental: '',

            // DM
            sopList: [],
            sopListId: null,
            policyList: [],
            policyListId: null,
            healthSafetyList: [],
            healthSafetyListId: null,
            riskAssesmentList: [],
            riskAssesmentListId: null,
            envirenmentalList: [],
            envirenmentalListId: null,
          },
          allCompanyUserList: [],
          pickerOptions2: {
            // disabledDate(time) {
            //   console.log(time)
            //   return time.getTime() > Date.now();
            // },
            disabledDate: this.disabledDueDate,
            shortcuts: [{
              text: 'Last week',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: 'Last month',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: 'Last 3 months',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit('pick', [start, end]);
              }
            }]
          },
          rules: {
            taskName: [
              { required: true, message: 'Please input Task name', trigger: 'blur' }
            ],
            taskStageId: [
              { required: true, message: 'Please select Task Stage', trigger: 'change' }
            ],
            taskPriorityId:[
              { required: true, message: 'Please select Task Priority', trigger: 'change' }
            ],
            Date: [
              { required: true, message: 'Please pick a date', trigger: 'blur' }
            ],
            // assignedToId: [
            //   { required: true, message: 'Please pick a Assigned', trigger: 'blur' }
            // ],
            // taskTeamId: [
            //   { required: true, message: 'Please pick a Task Team', trigger: 'blur' }
            // ],
            typeTaskId: [
              { required: true, message: 'Please pick a Task Type', trigger: 'blur' }
            ],
            businessUnitId: [
              { required: true, message: 'Please select Business Unit', trigger: 'blur' }
            ],
            functionTaskId:[
              { required: true, message: 'Please pick a Task Function', trigger: 'blur' }
            ]
          }
        }
      },
      watch: {
        'formAddTask.Date': function (val) {
          if (this.stateTask !== 'edit') {
            // let time = moment(val[1], 'DD-MM-YYYY').format('YYYY-MM-DD').toString()

            // if (Date.parse(time) < Date.now().toString()) {
            if (val[1] < Date.now()) {
              this.$confirm('End date is set before current date, do you want to continue?', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Back',
                type: 'info'
              }).then(() => {

              }).catch(() => {
                // this.formAddTask.Date = []
              });
            }
          } else {
            // TODO
            if (this.countOpenModal > 1) {
              // let time = moment(val[1], 'DD-MM-YYYY').format('YYYY-MM-DD').toString()

              // if (Date.parse(time) < Date.now().toString()) {
              if (val[1] < Date.now()) {
                this.$confirm('End date is set before current date, do you want to continue?', {
                  confirmButtonText: 'OK',
                  cancelButtonText: 'Back',
                  type: 'info'
                }).then(() => {

                }).catch(() => {
                  // this.formAddTask.Date = []
                });
              }
            } else {
              this.countOpenModal = this.countOpenModal + 1
            }
          }
        },
      },
      methods: {
        testing(){
          console.log(this.formAddTask.taskTeam)
        },
        modalCancel(ref) {
          this.$refs[ref].close();
        },
        disabledDueDate (time) {
          console.log(Number(moment(this.maximumDate, 'DDMMYYYY').format('x')));
          console.log(Date.now());
          console.log('ma time', time)
          let start = time.getTime() < Number(moment(this.minimumDate, 'DDMMYYYY').format('x'));
          let end = time.getTime() > Number(moment(this.maximumDate, 'DDMMYYYY').format('x'));
          if (start){
            return start
          }else if(end){
            return end
          }
        },
        // setBusinessUnitsId(businessUnitsId) {
        //   this.businessUnitsUsers = []
        //   this.businessUnitsUsersId = []

        //   let list = []
        //   for (let index = 0; index < this.companyUserList.length; index++) {
        //     if (this.companyUserList[index].businessUnitId == businessUnitsId) {
        //       list.push(this.companyUserList[index].user)
        //     }
        //   }
        //   this.businessUnitsUsers = list
        // },
        ggg(value) {
          console.log('this.newVendorList', this.newVendorList);
          console.log(value)
        },
        // createMyList(vendorList, vendorPersonList){
        //   console.log('vendorList', vendorList)
        //   console.log('vendorPersonList', vendorPersonList)
        //   let myVendorList = []
        //   let myVendor = {
        //     companyVendor: {id: '3', name: "Company vendor"},
        //     companyVendorId: 3,
        //     id: 20,
        //     projectId: 3,
        //     vendorPersons: []
        //   }
        //   for(let i = 0; i < vendorList.length; i++){
        //         myVendor.companyVendor.id = vendorList[i].companyVendor.id
        //         myVendor.companyVendor.name = vendorList[i].companyVendor.name
        //         myVendor.companyVendorId = vendorList[i].companyVendorId
        //         myVendor.id = vendorList[i].id
        //         myVendor.projectId = vendorList[i].projectId
        //         for(let b = 0; b < vendorPersonList.length; b++){
        //           if(vendorList[i].companyVendorId === vendorPersonList[b].companyVendorId){
        //               myVendor.vendorPersons.push(vendorPersonList[b])
        //             }
        //           }
        //         console.log('My vendor', myVendor)
        //       myVendorList.push(myVendor)
        //     console.log('vendorPersonListITEM', vendorPersonList[i])
        //     console.log('vendorListITEM', vendorList[i])
        //   }
        //   console.log('myVendorList', myVendorList)
        //   return myVendorList
        // },
        deselect(node, instanceId){
          if (this.formAddTask.assignedToId === node.id) {
            this.formAddTask.assignedToId = null;
            this.formAddTask.businessUnitId = null;
            this.formAddTask.businessUnitList = []
          }
          this.formAddTask.assignedTo = this.formAddTask.assignedTo.filter(leader => leader.id !== node.id)
        },
        selectTeam(node, instanceId){
          console.log(node)
          const uniqueUser = this.companyUserList.filter(val => val.id === node.id)[0];
          this.formAddTask.assignedTo.push(uniqueUser)
        },
        beforeClearAll(){
          // CLEAR LEADER IF DELETE ALL TEAM
          if (this.formAddTask.assignedToId) {
            this.formAddTask.assignedToId = null;
            this.formAddTask.businessUnitId = null;
            this.formAddTask.businessUnitList = []
          }
          this.formAddTask.assignedTo = [];
          return true
        },
        handleSelectLeader(leaderId){
          const even = (element) => element === leaderId;
          const ifUserInTeam = this.formAddTask.taskTeamId.some(even);
          if (!ifUserInTeam) {
            this.formAddTask.taskTeamId.push(leaderId)
          }
          this.formAddTask.businessUnitList = [];
          // get all bu ids which added to that user
          const ids = [];
          this.companyUserList.forEach(val =>{
            if(val.id === leaderId){
              ids.push(val.businessUnitId)
            }
          });
          // get all bu by current user
          ids.forEach(id => {
            this.businessUnits.forEach(bu => {
              if (id === bu.id) this.formAddTask.businessUnitList.push(bu)
            })
          });
          this.formAddTask.businessUnitList.sort(function(a, b){
            if(a.name < b.name) { return -1; }
            if(a.name > b.name) { return 1; }
            return 0;
          })
        },
        clearLeader(){
          this.formAddTask.businessUnitList = [];
          this.formAddTask.businessUnitId = null
        },
        createMyList(list, personList, state) {
          const myList = [];

          for (let i = 0; i < list.length; i++) {
            myList.push({ ...list[i], people: [] })
              if(state === 'vendors'){
                for (let j = 0; j < personList.length; j++) {
                  if (list[i].companyVendorId === personList[j].companyVendorId) {
                    myList[i].people.push(personList[j])
                    // personList.splice(j, 1)
                  }
                }
              }
              if(state === 'clients'){
                for (let j = 0; j < personList.length; j++) {
                  if (list[i].companyClientId === personList[j].companyClientId) {
                    myList[i].people.push(personList[j])
                    // personList.splice(j, 1)
                  }
                }
              }
          }
          console.log('myList11', myList)
          return myList
        },
        addTask(state) {
          this.$refs.addTask.open();
          let loader = this.$loading.show();
          this.stateTask = state
          // console.log('---', 'add');
          // if(this.stateTask === 'add' && this.selectedRow.type === "task" && this.selectedRow.taskStatus === 2 && this.firstEntering === false){
          //   this.firstEntering = true
          //   this.$refs.addParent.open();
          //   return
          // }
          // this.firstEntering = false
          let operation = ''
          if(state === 'add'){
            operation = 'create'
          }else if(state === 'edit'){
            operation = 'update'
          }else if (state === 'insert'){
            operation = 'create'
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/projectTasks/directories?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&operation=${operation}`)
            .then(response => {
              if(state === 'add' || state === 'edit' || state === 'insert'){
                console.log('---', response.data);

                this.businessUnits = response.data.businessUnitList
                // this.companyUserList = response.data.companyUserList
                this.allCompanyUserList = response.data.allCompanyUserList;

                var result = [];
                for (var index = 0; index < response.data.businessUnitList.length; index++) {
                  var businessUnit = response.data.businessUnitList[index];
                  var children = [];
                  for (var index2 = 0; index2 < response.data.companyUserList.length; index2++) {
                    var companyUser = response.data.companyUserList[index2];
                    if (companyUser.businessUnitId == businessUnit.id) {
                      children.push({
                        id: companyUser.id,
                        label: companyUser.user.fullName,
                        status: companyUser.status
                      })
                    }
                  }
                  // if (children.length > 0) {
                    result.push({
                      // id: businessUnit.id,
                      id: businessUnit.name,
                      label: businessUnit.name,
                      children: children,
                    })
                  // }
                }
                console.log('---DDDDDDDDDDDDDDDDDDDD', result);


                this.formAddTask.taskTeam = result
                this.companyUserList = response.data.companyUserList
                console.log('---DDDDDDDDDEEEEEEEEEEEEEEEEEE', this.formAddTask.taskTeam );



                if (response.data.projectStartDate.toString().length < 8) {
                  this.minimumDate = '0' + response.data.projectStartDate.toString()
                } else {
                  this.minimumDate = response.data.projectStartDate
                }
                if (response.data.projectDeadlineDate.toString().length < 8) {
                  this.maximumDate = '0' + response.data.projectDeadlineDate.toString()
                } else {
                  this.maximumDate = response.data.projectDeadlineDate
                }

                // DM
                this.formAddTask.sopList = response.data.sopList
                this.formAddTask.policyList = response.data.policyList
                this.formAddTask.healthSafetyList = response.data.healthSafetyList
                this.formAddTask.riskAssesmentList = response.data.riskAssesmentList
                this.formAddTask.envirenmentalList = response.data.envirenmentalList

                this.formAddTask.taskStage = response.data.companyStageList
                this.formAddTask.taskStageId = response.data.companyStageList[0].id
                this.formAddTask.taskPriority = response.data.priorityList
                this.formAddTask.taskPriorityId = response.data.priorityList[1].id
                // this.formAddTask.assignedTo = response.data.companyUserList.filter((thing, index, self) =>
                //   index === self.findIndex((t) => (
                //     t.id === thing.id
                //   ))
                // );

                // if(response.data.projectUserList.length > 0){
                //   this.formAddTask.assignedToId = response.data.projectUserList[0].id
                // }
                // this.formAddTask.taskTeam = response.data.projectUserList

                // this.formAddTask.projectClientList = response.data.projectClientList
                // this.formAddTask.projectlist = response.data.projectVendorList

                this.newVendorList = this.createMyList(response.data.projectVendorList, response.data.projectVendorPersonList, 'vendors')
                this.newClientList = this.createMyList(response.data.projectClientList, response.data.projectClientPersonList, 'clients')

                this.formAddTask.typeTask = response.data.taskTypeList
                // this.formAddTask.typeTaskId = response.data.taskTypeList[0].id
                loader.hide()
                this.$nextTick(() => {
                  this.$refs.editor.setImagesState()
                })
                if(state === 'add'){
                  loader.hide()
                  // if(response.data.companyUserList.length > 0){
                  //   for (let i = 0; i < response.data.companyUserList.length; i++){
                  //     this.formAddTask.taskTeamId.push(response.data.companyUserList[i].id)
                  //   }
                  // }
                }
              }
              if (state === 'edit'){

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
                axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
                axios.post(`/api/v1/projectTasks/item?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.selectedRow.id}`)
                  .then(response => {
                    console.log('SELECTED Project ROW INFO', response.data.item);

                    // let start = response.data.item.startDate.toString();
                    // if (start.length < 8) {
                    //   start = '0' + start
                    // }
                    // let end = response.data.item.deadlineDate.toString();
                    // if (end.length < 8) {
                    //   end = '0' + end
                    // }
                    // this.formAddTask.Date[0] = moment.utc(start, "DDMMYYYY").toDate()
                    // this.formAddTask.Date[1] = moment.utc(end, "DDMMYYYY").toDate()
                    this.formAddTask.Date.push(response.data.item.startDate);
                    this.formAddTask.Date.push(response.data.item.deadlineDate);
                    this.formAddTask.taskName = response.data.item.name;
                    this.formAddTask.aboutThisTask = response.data.item.description;
                    this.formAddTask.taskStageId = response.data.item.companyStageId;
                    this.formAddTask.taskPriorityId = response.data.item.priorityId;
                    //filter users
                    const allIds = response.data.item.companyUserIdList.concat(response.data.item.shareProjectTaskCompanyUserList.map(el => el.companyUser.id));
                    this.formAddTask.taskTeamId = allIds.filter(function(a){
                      return allIds.indexOf(a) === allIds.lastIndexOf(a)
                    });
                    this.formAddTask.assignedToId = response.data.item.leaderCompanyUserId;
                    // set list to leader from team
                    // this.formAddTask.assignedTo = [];
                    this.formAddTask.taskTeamId.forEach(val => {
                      const user = this.allCompanyUserList.filter(user => user.id === val)[0];
                      this.formAddTask.assignedTo.push(user)
                    });
                    this.formAddTask.businessUnitId = response.data.item.businessUnitId;
                    this.formAddTask.sharedTeamId = response.data.item.shareProjectTaskCompanyUserList.map(el => el.companyUser.id);
                    // this.formAddTask.taskTeamId = response.data.item.companyUserIdList
                    this.formAddTask.shareProjectTaskCompanyUserList = response.data.item.shareProjectTaskCompanyUserList.map(el => el.companyUser);
                    if(response.data.item.allowExternalNotifications){
                      if(response.data.item.allowExternalNotifications === 1){
                        this.formAddTask.allowExternalNotification = true
                      }else{
                        this.formAddTask.allowExternalNotification = false
                      }
                    }
                    if(response.data.item.allowSharing){
                      if (response.data.item.allowSharing === 1) {
                        this.formAddTask.allowSharing = true
                      } else {
                        this.formAddTask.allowSharing = false
                      }
                    }
                    // this.formAddTask.allowExternalNotification = response.data.item.allowExternalNotifications
                    this.formAddTask.projectClientListId = response.data.item.companyClientPersonIdList;
                    this.formAddTask.projectVendorListId = response.data.item.companyVendorPersonIdList;
                    this.formAddTask.typeTaskId = response.data.item.taskTypeId;
                    this.formAddTask.functionTaskId = response.data.item.taskFunctionId || 1;
                    this.formAddTask.addTaskDocuments = !!response.data.item.addTaskDocument;

                    // DM
                    this.formAddTask.sopListId = response.data.item.sopId;
                    this.formAddTask.policyListId = response.data.item.policyId;
                    this.formAddTask.healthSafetyListId = response.data.item.healthSafetyId;
                    this.formAddTask.riskAssesmentListId = response.data.item.riskAssesmentId;
                    this.formAddTask.envirenmentalListId = response.data.item.envirenmentalId;

                    // CHECK IF MANAGER OF PROJECT CHANGED OR UR USER WAS DELETED FROM BU START
                    if (this.formAddTask.taskTeamId.length) {
                      const usersWithoutBu = {
                        id: 'Team',
                        label: 'Team',
                        children: []
                      };
                      let ifFound = false;
                      // CHECK IF USER IN BU LISTS ATTACHED TO PROJECT
                      this.formAddTask.taskTeamId.forEach(id => {
                        const even = (element) => element.id === id;
                        const ifUserInCompanyUserList = this.companyUserList.some(even);
                        if (!ifUserInCompanyUserList) {
                          ifFound = true;
                          this.allCompanyUserList.forEach(function (val) {
                            if (id === val.id) {
                              usersWithoutBu.children.push({
                                id: val.id,
                                label: val.user.fullName,
                                status: val.status
                              })
                            }
                          });
                        }
                      });
                      if (ifFound) {
                        this.formAddTask.taskTeam.push(usersWithoutBu);
                      }
                    }
                    // CHECK IF MANAGER OF PROJECT CHANGED OR UR USER WAS DELETED FROM BU END

                    this.handleTaskFunctions('getTaskFunctionList', response.data.item.taskTypeId)

                    // startDate: startDate,
                    // deadlineDate: deadLineDate,

                    // show all BUs leader of task
                    const ids = [];
                    this.companyUserList.forEach(val =>{
                      if(val.id === response.data.item.leaderCompanyUserId){
                        ids.push(val.businessUnitId)
                      }
                    });
                    // get all bu by current user
                    ids.forEach(id => {
                      this.businessUnits.forEach(bu => {
                        if (id === bu.id) this.formAddTask.businessUnitList.push(bu)
                      })
                    });
                    // parentProjectTaskId: this.projectTaskId
                    loader.hide()
                    // this.handleTaskFunctions('getTaskFunctionList', response.data.item.taskTypeId)
                    this.$nextTick(() => {
                      this.$refs.editor.setImagesState()
                    })
                  })
                  .catch(error => {
                    loader.hide()
                    if (error.response.data.statusCode == 401) {
                      localStorage.clear();
                      this.$router.push('/login')
                    }
                    console.log('An error occurred:', error);
                  });
                console.log('---', 'edit')
              }
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        },
        handleTaskFunctions(state, id) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/projectTasks/directories?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&operation=${state}&taskTypeId=${id}`)
            .then(response => {
              console.log(response)
              this.formAddTask.functionTask = response.data.taskFunctionList
              loader.hide()
            })
            .catch(error => {
              this.notification("Notification", error.response.data.message, "info")
              console.log('An error occurred:', error);
              loader.hide()
            })
        },
        addParentTask(state){
          this.addTask(state)
        },
        addTaskSubmit(form) {
          console.log(form)
          console.log('SELECTED ROW Type', this.selectedRow.type);
          if (this.selectedRow.type === "project") {
            this.projectTaskId = null;
          } else {
            this.projectTaskId = this.selectedRow.id;
          }
          if(this.selectedRow.type === "task" && this.selectedRow.taskStatus === 2 || this.selectedRow.type === "task" && this.selectedRow.taskStatus === 5){
            this.createTaskParent(form)
          }else{
            this.$refs[form].validate((valid) => {
              if (valid) {
                // const startDate = moment(this.formAddTask.Date[0]).format('DDMMYYYY');
                // const deadLineDate = moment(this.formAddTask.Date[1]).format('DDMMYYYY')

                if (!this.formAddTask.addTaskDocuments) {
                  this.formAddTask.sopListId = null
                  this.formAddTask.policyListId = null
                  this.formAddTask.healthSafetyListId = null
                  this.formAddTask.riskAssesmentListId = null
                  this.formAddTask.envirenmentalListId = null
                }

                let loader = this.$loading.show();
                axios
                  .post(`/api/v1/projectTasks/create?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}`, {
                    name: this.formAddTask.taskName,
                    description: this.formAddTask.aboutThisTask,
                    priorityId: this.formAddTask.taskPriorityId,
                    companyStageId: this.formAddTask.taskStageId,
                    startDate: this.formAddTask.Date[0],
                    deadlineDate: this.formAddTask.Date[1],
                    leaderCompanyUserId: this.formAddTask.assignedToId,
                    companyUserIdList: this.formAddTask.taskTeamId,
                    allowExternalNotifications: this.formAddTask.allowExternalNotification,
                    allowSharing: this.formAddTask.allowSharing,
                    companyClientPersonIdList: this.formAddTask.projectClientListId,
                    companyVendorPersonIdList: this.formAddTask.projectVendorListId,
                    taskTypeId: this.formAddTask.typeTaskId,
                    parentProjectTaskId: this.projectTaskId,
                    taskFunctionId: this.formAddTask.functionTaskId,
                    addTaskDocument: this.formAddTask.addTaskDocuments,
                    businessUnitId: this.formAddTask.businessUnitId,
                    // DM
                    sopId: this.formAddTask.sopListId,
                    policyId: this.formAddTask.policyListId,
                    healthsafetyId: this.formAddTask.healthSafetyListId,
                    riskAssesmentId: this.formAddTask.riskAssesmentListId,
                    envirenmentalId: this.formAddTask.envirenmentalListId,
                  })
                  .then(response => {
                    // Handle success.
                    // console.log('Your user received an email');
                    // console.log('AFTER CREATED TASK RESPONSE', response.data);
                    // loader.hide()
                    if (this.$refs.editor.uploadedImagesArray.length) {
                      this.$store.dispatch('approveUploadedImages', {
                        fileUrlArr: this.$refs.editor.uploadedImagesArray,
                        entityId: this.projectTaskId,
                        entityTypeId: 25 // project task about entity
                      })
                    }
                    this.$refs.addTask.close();
                    this.notification("Success", "Add task", "success");
                    loader.hide();
                    // this.newCreatedProjectTask = response.data.projectTaskId
                    // this.setProjectRowData(this.activeProjectId)
                    this.$emit('submit', this.activeProjectId, false, response.data.projectTaskId)
                  })
                  .catch(error => {
                    // Handle error.
                    // this.notification("Notification", error.response.data.message, "info")
                    // console.log('An error occurred:', error);
                    // if (error.response.data.message === "invalid_email_value") this.notification("Notification", "Invalid email value", "info");
                    // if (error.response.data.message === "invalid_password_value") this.notification("Notification", "Invalid password value", "info");
                    loader.hide();
                  });
              } else {
                console.log('error submit!!');
                return false;
              }
            });
          }
        },
        addTaskInsert(form) {
          console.log(form);
          console.log('SELECTED ROW Type', this.selectedRow.type);
          if (this.selectedRow.type === "project") {
            // if selected project just create task
            this.addTaskSubmit('formAddTask');
            return
          } else {
            this.projectTaskId = this.selectedRow.id;
          }
            this.$refs[form].validate((valid) => {
              if (valid) {
                // const startDate = moment(this.formAddTask.Date[0]).format('DDMMYYYY');
                // const deadLineDate = moment(this.formAddTask.Date[1]).format('DDMMYYYY')

                if (!this.formAddTask.addTaskDocuments) {
                  this.formAddTask.sopListId = null
                  this.formAddTask.policyListId = null
                  this.formAddTask.healthSafetyListId = null
                  this.formAddTask.riskAssesmentListId = null
                  this.formAddTask.envirenmentalListId = null
                }

                let loader = this.$loading.show();
                axios
                  .post(`/api/v1/projectTasks/insert?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&orderIndex=${this.selectedRow.orderIndex}`, {
                    name: this.formAddTask.taskName,
                    description: this.formAddTask.aboutThisTask,
                    priorityId: this.formAddTask.taskPriorityId,
                    companyStageId: this.formAddTask.taskStageId,
                    startDate: this.formAddTask.Date[0],
                    deadlineDate: this.formAddTask.Date[1],
                    leaderCompanyUserId: this.formAddTask.assignedToId,
                    companyUserIdList: this.formAddTask.taskTeamId,
                    allowExternalNotifications: this.formAddTask.allowExternalNotification,
                    allowSharing: this.formAddTask.allowSharing,
                    companyClientPersonIdList: this.formAddTask.projectClientListId,
                    companyVendorPersonIdList: this.formAddTask.projectVendorListId,
                    taskTypeId: this.formAddTask.typeTaskId,
                    businessUnitId: this.formAddTask.businessUnitId,
                    parentProjectTaskId: this.selectedRow.parentProjectTaskId,
                    taskFunctionId: this.formAddTask.functionTaskId,
                    addTaskDocument: this.formAddTask.addTaskDocuments,
                    // DM
                    sopId: this.formAddTask.sopListId,
                    policyId: this.formAddTask.policyListId,
                    healthsafetyId: this.formAddTask.healthSafetyListId,
                    riskAssesmentId: this.formAddTask.riskAssesmentListId,
                    envirenmentalId: this.formAddTask.envirenmentalListId,
                  })
                  .then(response => {
                    // Handle success.
                    console.log('Your user received an email');
                    console.log('AFTER CREATED TASK RESPONSE', response.data);
                    if (this.$refs.editor.uploadedImagesArray.length) {
                      this.$store.dispatch('approveUploadedImages', {
                        fileUrlArr: this.$refs.editor.uploadedImagesArray,
                        entityId: this.projectTaskId,
                        entityTypeId: 25 // project task about entity
                      })
                    }
                    loader.hide()
                    this.$refs.addTask.close();
                    this.notification("Success", "Add task", "success");
                    // this.newCreatedProjectTask = response.data.projectTaskId
                    // this.setProjectRowData(this.activeProjectId)
                    this.$emit('submit', this.activeProjectId, false, response.data.projectTaskId)
                  })
                  .catch(error => {
                    // Handle error.
                    // this.notification("Notification", error.response.data.message, "info")
                    // console.log('An error occurred:', error);
                    // if (error.response.data.message === "invalid_email_value") this.notification("Notification", "Invalid email value", "info");
                    // if (error.response.data.message === "invalid_password_value") this.notification("Notification", "Invalid password value", "info");
                    loader.hide();
                  });
              } else {
                console.log('error submit!!');
                return false;
              }
            });
        },
        createTaskParent(form){
          this.$refs[form].validate((valid) => {
            if (valid) {
              // const startDate = moment(this.formAddTask.Date[0]).format('DDMMYYYY');
              // const deadLineDate = moment(this.formAddTask.Date[1]).format('DDMMYYYY')

              if (!this.formAddTask.addTaskDocuments) {
                this.formAddTask.sopListId = null
                this.formAddTask.policyListId = null
                this.formAddTask.healthSafetyListId = null
                this.formAddTask.riskAssesmentListId = null
                this.formAddTask.envirenmentalListId = null
              }

              let loader = this.$loading.show();
              axios
                .post(`/api/v1/projectTasks/createParent?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&childProjectTaskId=${this.projectTaskId}`, {
                  name: this.formAddTask.taskName,
                  description: this.formAddTask.aboutThisTask,
                  priorityId: this.formAddTask.taskPriorityId,
                  companyStageId: this.formAddTask.taskStageId,
                  startDate: this.formAddTask.Date[0],
                  deadlineDate: this.formAddTask.Date[1],
                  leaderUserId: this.formAddTask.assignedToId,
                  companyUserIdList: this.formAddTask.taskTeamId,
                  allowExternalNotifications: this.formAddTask.allowExternalNotification,
                  allowSharing: this.formAddTask.allowSharing,
                  companyClientIdList: this.formAddTask.projectClientListId,
                  companyVendorIdList: this.formAddTask.projectVendorListId,
                  taskTypeId: this.formAddTask.typeTaskId,
                  businessUnitId: this.formAddTask.businessUnitId,
                  taskFunctionId: this.formAddTask.functionTaskId,
                  addTaskDocument: this.formAddTask.addTaskDocuments,
                  // DM
                  sopId: this.formAddTask.sopListId,
                  policyId: this.formAddTask.policyListId,
                  healthsafetyId: this.formAddTask.healthSafetyListId,
                  riskAssesmentId: this.formAddTask.riskAssesmentListId,
                  envirenmentalId: this.formAddTask.envirenmentalListId,
                })
                .then(response => {
                  // Handle success.
                  console.log('Your user received an email');
                  console.log('AFTER CREATED TASK RESPONSE', response.data);
                  if (this.$refs.editor.uploadedImagesArray.length) {
                    this.$store.dispatch('approveUploadedImages', {
                      fileUrlArr: this.$refs.editor.uploadedImagesArray,
                      entityId: this.projectTaskId,
                      entityTypeId: 25 // project task about entity
                    })
                  }
                  this.$refs.addTask.close();
                  this.notification("Success", "Add task", "success");
                  loader.hide();
                  let id = this.activeProjectId;
                  // this.newCreatedProjectTask = response.data.projectTaskId
                  // this.setProjectRowData(id)
                  this.$emit('submit', id, false, response.data.projectTaskId)
                })
                .catch(error => {
                  // Handle error.
                  // this.notification("Notification", error.response.data.message, "info")
                  // console.log('An error occurred:', error);
                  // if (error.response.data.message === "invalid_email_value") this.notification("Notification", "Invalid email value", "info");
                  // if (error.response.data.message === "invalid_password_value") this.notification("Notification", "Invalid password value", "info");
                  loader.hide()
                });
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        editTaskSubmit(form) {
          console.log('SELECTED ROW Type', this.selectedRow.type);
          if (this.selectedRow.type === "project") {
            this.projectTaskId = null;
          } else {
            this.projectTaskId = this.selectedRow.id;
          }
          this.$refs[form].validate((valid) => {
            if (valid) {
              // const startDate = moment(this.formAddTask.Date[0]).format('DDMMYYYY');
              // const deadLineDate = moment(this.formAddTask.Date[1]).format('DDMMYYYY')

              if (!this.formAddTask.addTaskDocuments) {
                this.formAddTask.sopListId = null
                this.formAddTask.policyListId = null
                this.formAddTask.healthSafetyListId = null
                this.formAddTask.riskAssesmentListId = null
                this.formAddTask.envirenmentalListId = null
              }

              let loader = this.$loading.show();
              axios
                .post(`/api/v1/projectTasks/update?companyId=${this.$route.query.companyId}&projectId=${this.$route.query.projectId}&projectTaskId=${this.projectTaskId}`, {
                  name: this.formAddTask.taskName,
                  description: this.formAddTask.aboutThisTask,
                  companyStageId: this.formAddTask.taskStageId,
                  priorityId: this.formAddTask.taskPriorityId,
                  startDate: this.formAddTask.Date[0],
                  deadlineDate: this.formAddTask.Date[1],
                  companyUserIdList: this.formAddTask.taskTeamId.concat(this.formAddTask.sharedTeamId),
                  allowExternalNotifications: this.formAddTask.allowExternalNotification,
                  allowSharing: this.formAddTask.allowSharing,
                  companyClientPersonIdList: this.formAddTask.projectClientListId,
                  companyVendorPersonIdList: this.formAddTask.projectVendorListId,
                  businessUnitId: this.formAddTask.businessUnitId,
                  leaderCompanyUserId: this.formAddTask.assignedToId || null,
                  taskTypeId: this.formAddTask.typeTaskId,
                  taskFunctionId: this.formAddTask.functionTaskId,
                  addTaskDocument: this.formAddTask.addTaskDocuments,
                  // DM
                  sopId: this.formAddTask.sopListId,
                  policyId: this.formAddTask.policyListId,
                  healthsafetyId: this.formAddTask.healthSafetyListId,
                  riskAssesmentId: this.formAddTask.riskAssesmentListId,
                  envirenmentalId: this.formAddTask.envirenmentalListId,

                  // parentProjectTaskId: this.projectTaskId
                })
                .then(response => {
                  // Handle success.
                  if (this.$refs.editor.uploadedImagesArray.length) {
                    this.$store.dispatch('approveUploadedImages', {
                      fileUrlArr: this.$refs.editor.uploadedImagesArray,
                      entityId: this.projectTaskId,
                      entityTypeId: 25 // project task about entity
                    })
                  }

                  if (this.$refs.editor.removedImages.length) {
                    this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                  }
                  this.$refs.addTask.close();
                  this.notification("Success", "Edit task", "success");
                  loader.hide()
                  let id = this.activeProjectId
                  this.$emit('submit', id, false, this.selectedRow.id)
                })
                .catch(error => {
                  // Handle error.
                  // this.notification("Notification", error.response.data.message, "info")
                  // console.log('An error occurred:', error);
                  // if (error.response.data.message === "invalid_email_value") this.notification("Notification", "Invalid email value", "info");
                  // if (error.response.data.message === "invalid_password_value") this.notification("Notification", "Invalid password value", "info");
                  loader.hide()
                });
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        closeTaskModal(){
          this.countOpenModal = 0
          this.formAddTask.taskName = 'My Task'
          this.formAddTask.aboutThisTask = null
          this.formAddTask.taskStage = []
          this.formAddTask.taskStageId = ''
          this.formAddTask.taskPriority = []
          this.formAddTask.Date = []
          this.formAddTask.taskPriorityId = ''
          this.formAddTask.assignedTo = []
          this.formAddTask.assignedToId = null
          this.formAddTask.taskTeam = []
          this.formAddTask.taskTeamId = null
          this.formAddTask.businessUnitId = null
          this.formAddTask.businessUnitList = []

          this.formAddTask.projectClientList = ''
          this.formAddTask.projectClientListId = []
          this.formAddTask.projectVendorList = ''
          this.formAddTask.projectVendorListId = []
          this.formAddTask.typeTask = ''
          this.formAddTask.typeTaskId = ''
          this.formAddTask.functionTaskId = ''
          this.formAddTask.functionTask = []
          this.formAddTask.allowExternalNotification = false

          this.formAddTask.sopList = []
          this.formAddTask.sopListId = null
          this.formAddTask.policyList = []
          this.formAddTask.policyListId = null
          this.formAddTask.healthSafetyList = []
          this.formAddTask.healthSafetyListId = null
          this.formAddTask.riskAssesmentList = []
          this.formAddTask.riskAssesmentListId = null
          this.formAddTask.envirenmentalList = []
          this.formAddTask.envirenmentalListId = null
          this.formAddTask.addTaskDocuments = false
          this.allCompanyUserList = [];
          this.businessUnits = [];
          this.companyUserList = [];
          this.$refs['formAddTask'].resetFields()
        },
        notification(title, message, type) {
          this.$notify({
            title: title,
            message: message,
            type: type
          });
        }
      }
    }
</script>

<style lang="less" scoped>
  .sweet-modal-overlay{
    z-index:1000;
  }
  .modal{
    text-align:left;
  }
  .flex-center{
    display: flex;
    justify-content: center;
  }
  .flex-end{
    display:flex;
    justify-content: flex-end;
  }
  .flex{
    display: flex;
    justify-content:space-between;
  }
  .two-columns > div{
    max-width:45%;
    width:100%;
  }
  .el-form-item{
    .el-select{
      width:100%;
    }
  }
  .aboutButton{
    // margin-left:100px;
    // margin-bottom:15px;
    display: flex;
    justify-content: center;
    margin-bottom: 18px;
  }
  /*.el-form-item__label{*/
      /*text-align:right;*/
  /*}*/
  /deep/.el-range-separator{
    position:relative;
    &::before{
      color: #C0C4CC;
      font-family: "element-icons";
      position:absolute;
      content: "\E78E";
      left:5px;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }
  }
</style>

<style lang="less">
  .select-group{
    .el-select-group__title{
      cursor:pointer !important;
    }
  }

  .vue-treeselect__multi-value-item {
    border: 1px solid #e9e9eb;
    border-radius: 4px;
    background: #f4f4f5;
    color: #909399;
    padding: 0px 0;
  }
  .vue-treeselect__value-remove {
    color: #909399;
  }

  .disabled {
    // background: #f2f2f2;
    color: red !important;
  }
</style>
